import { useContext } from "react";
import {
  NavigationContext,
  NavigationProviderContext,
} from "./NavigationProvider";

const useNavigationContext = (): NavigationProviderContext =>
  useContext(NavigationContext);

export { useNavigationContext };
